import { render, staticRenderFns } from "./today-game.vue?vue&type=template&id=0c115af8&"
import script from "./today-game.vue?vue&type=script&lang=js&"
export * from "./today-game.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports